import Api from "../../../../util/Api";

export default function getInitState() {
    return {
        patientAppointmentTableIsShow: true,
        patientDisbandTableIsShow: false,
        patientAttendanceWrapperIsShow: false,

        patientAttendanceTableIsShow: false,
        patientAttendanceDetailsIsShow: false,

        patientAttendanceEKatalogusFormIsShow: false,

        patientEvidenceContentIsShow: true,
        patientEvidenceFormIsShow: false,
        patientEvidenceFormFinalizeIsShow: false,

        EHREvidenceFormIsShow: false,

        covidRapidAntigenTestFormIsShow: false,

        patientAppointmentTableAdditionalConfig: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        patientAppointmentTableActions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            }
        ],
        patientAppointmentTableRowActions: [
            {
                btn_text: '<i class="far fa-folder"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'showDetails',
                additionalButtonVisible: "isShowPatientShowDetailsButton"
            },
            {
                btn_text: '<i class="far fa-money-bill-alt"></i>',
                title: 'Elbocsátás/Fizetés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'disbandPatient',
                additionalButtonVisible: "isShowPayButton"
            }
        ],
        patientAppointmentTableSearchFields: [
            {
                label: "Név",
                name: 'patientName',
                formSize: 4,
                formType: 'text',
                formVisible: true
            },
            {
                label: "TAJ",
                name: 'socialInsuranceNumber',
                formSize: 4,
                formType: 'text'
            },
            {
                label: "Technikai azonosító",
                name: "prefixedId",
                formType: "text",
                formSize: 4,
                formVisible: true,
            },
            {
                label: "E-mail cím",
                name: 'email',
                formSize: 4,
                formType: 'email',
                formVisible: true
            },
            {
                label: "Születési dátum",
                name: 'dateOfBirth',
                formSize: 4,
                formType: 'date'
            },
            {
                label: "Időponttól",
                name: 'appointmentFrom',
                formSize: 4,
                formType: 'date'
            },
            {
                label: "Időpontig",
                name: 'appointmentTo',
                formSize: 4,
                formType: 'date'
            },
            {
                name: "companySiteId",
                label: "Telephely",
                description: "Amennyiben nincs kiválasztva telephely, minden telephelyre vonatkozik a keresés",
                formSize: 4,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getCompanySitesByCompanyId,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
            },
            {
                name: "doctorId",
                label: "Orvos",
                formSize: 4,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllDoctor,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "treatmentId",
                label: "Kezelés",
                formSize: 4,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getHRTreatment,
                    formatText: function (val) {
                        return val.title;
                    },
                    formatOption: function (val) {
                        return val.title;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'title',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
              name: 'employeeId',
              label: 'Törzsszám',
              formSize: 4,
              formType: 'text',
              formVisible: true
            },
            {
                name: 'contactId',
                label: 'Megkeresés',
                formSize: 4,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getContactsToSelect,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: 'partnerId',
                label: 'Partner',
                formSize: 4,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getPartnersToSelect,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
            }
        ],
        patientAppointmentTableHeaderFields: [
            {
                label: "Sorszám",
                name: "ticketNumber",
                //sort: true
            },
            {
                label: "Név",
                name: "patient.name",
                slot_name: "patientNameFormat"
                //sort: true
            },
            {
                label: "Taj",
                name: "patient.socialInsuranceNumber",
                //sort: true
            },
            {
                name: "patient.prefixedId",
                label: "Technikai azonosító",
            },
            {
                label: "Születési dátum",
                name: "patient.dateOfBirth",
                slot_name: 'dateOfBirth_format',
                //sort: true
            },
            {
                label: "Telefonszám",
                name: "patient.phoneNumber",
                slot_name: "patientPhoneNumberFormat"
                //sort: true
            },
            {
                label: "Időpont",
                name: "appointment",
                slot_name: "appointment_format",
                //sort: true
            },
            {
                label: "Előjegyzés állapot",
                name: "appointmentStatus.text",
                //sort: true
            },
            {
                label: "Orvos",
                name: "doctor.fullName",
                //sort: true
            },
            {
                label: "Kezelés",
                name: "treatment.title",
                //sort: true
            },
            {
                label: "Törzsszám",
                name: "siteGroupPatient.employeeId"
            },
            //{
                //label: "Kezelés állapot",
              //  name: "treatments[0].status.text",
                //sort: false
            //},
            {
                label: "Páciens",
                name: "patientId",
                visibility: true,
                slot_name: "format_patient"
                //sort: false
            },
            {
                label: "Opciók",
                name: "buttons",
                sort: false
            }
        ],

        patientAttendanceTableRowActions: [
            {
                btn_text: '<i class="far fa-folder"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'showPatientDetails',
                additionalButtonVisible: "showPatientAttendanceTableButtonIsAppointment"
            },
            {
                btn_text: '<i class="fas fa-file-contract"></i> COVID',
                title: 'COVID PCR eredmények az elmúlt 14 napban',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'getCovidPcrResults',
                additionalButtonVisible: "isShowGetCovidPcrResults"
            },
            {
                btn_text: '<i class="fas fa-edit"></i> Eseménykatalógus',
                title: 'Módosítás Eseménykatalógusban',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'showEditEKat',
                additionalButtonVisible: "isShowEditEkat"
            },
            {
                btn_text: '<i class="fas fa-plus"></i> eBeutaló',
                title: 'eBeutaló felhasználásának rögzítése',
                event_name: "customClick",
                class: "btn btn-outline-secondary",
                event_payload: 'showEBeuDialog',
                additionalButtonVisible: "isShowSetEBeuBtn"
            },
            {
                btn_text: '<i class="fas fa-share-square"></i>',
                title: 'Kiküldés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'sendPatientDocument',
            },
        ],
        patientAttendanceTableHeaderFields: [
            {
                label: "Időpont",
                name: "appointmentDate",
                slot_name: "today_appointment_format",
                filter: {
                    type: "simple",
                },
                sort: true,
                uniqueId: true
            },
            {
                label: "Ellátás",
                name: "attendanceText",
                filter: {
                    type: "simple",
                },
                sort: true,
                uniqueId: true
            },
            {
                label: "Kezelés",
                name: "treatmentTypeName",
                filter: {
                    type: "simple",
                },
                sort: true,
                uniqueId: true
            },
            {
                label: "Törzsszám",
                name: "employeeId",
                filter: {
                    type: "simple",
                },
                sort: true,
                uniqueId: true
            },
            {
                label: "Kórterem",
                name: "roomName",
                filter: {
                    type: "simple",
                },
                sort: true,
                uniqueId: true
            },
            {
                label: "Ágy",
                name: "badName",
                filter: {
                    type: "simple",
                },
                sort: true,
                uniqueId: true,
                visibility: false
            },
            {
                label: "Felvevő",
                name: "createdBy",
                filter: {
                    type: "simple",
                },
                sort: true,
                uniqueId: true
            },
            {
                label: "Állapot",
                name: "statusText",
                filter: {
                    type: "simple",
                },
                sort: true,
                uniqueId: true
            },
            {
                label: "EESZT ID",
                name: "eesztId",
                visibility: false
            },
            {
                label: "Beutaló EESZT ID",
                name: "eBeutaloEesztId",
                visibility: false
            },
            {
                label: "Opciók",
                name: "buttons",
                filter: {
                    type: "simple",
                },
                sort: false
            }
        ],

        patientDisbandTableAdditionalConfig: {
            checkbox_rows: true,
            show_refresh_button: true,
            show_reset_button: false,
            selected_rows_info: true,
            rows_selectable: true,
            global_search: {
                visibility: false,
            },
        },
        patientDisbandTableActions: [
            {
                btn_text: '<i class="fas fa-user-slash"></i> Elbocsát',
                event_name: "customClick",
                class: "btn btn-info my-custom-class",
                event_payload: 'disband'
            },
            {
                btn_text: '<i class="far fa-money-bill-alt"></i> Fizet',
                event_name: "on-click-pay",
                class: "btn btn-success  my-custom-class",
                event_payload: {
                    msg: "on-click-pay"
                }
            }
        ],
        patientDisbandTableHeaderFields: [
            {
                label: "id",
                name: "id",
                visibility: false,
                sort: false,
                uniqueId: true
            },
            {
                label: "Vizsgálat/Kezelés",
                name: "type.text",
                filter: {
                    type: "simple",
                },
                sort: true,
                uniqueId: false
            },
            {
                label: "Kezdés",
                name: "startDate",
                slot_name: "startDate_format",
                filter: {
                    type: "simple",
                },
                sort: true,
                uniqueId: false
            },
            {
                label: "Befejezés",
                name: "endDate",
                slot_name: "endDate_format",
                filter: {
                    type: "simple",
                },
                sort: true,
                uniqueId: false
            },
            {
                label: "Orvos",
                name: "doctor.fullName",
                filter: {
                    type: "simple",
                },
                sort: true,
                uniqueId: false
            },
            {
                label: "Státusz",
                name: "status.text",
                filter: {
                    type: "simple",
                },
                sort: true,
                uniqueId: false
            }
        ],

        patientEvidenceDocumentRowActions: [
            {
                btn_text: '<i class="far fa-folder"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'showEvidenceDocument'
            },
        ],
        patientEvidenceDocumentHeaderFields: [
            {
                label: "id",
                name: "Azonosító",
                visibility: false
            },
            {
                label: "Lelet azonosító",
                name: "patientEvidenceId",
                visibility: false
            },
            {
                label: "Fájl tartalom",
                name: "fileData",
                visibility: false
            },
            {
                label: "Fájl",
                name: "fileName",
                sort: true
            },
            {
                label: "Feltöltő",
                name: "createdBy",
                sort: true
            },
            {
                label: "Feltöltés dátuma",
                name: "createdOn",
                slot_name: "created_on_format",
                sort: true
            },
            {
                label: "Módosító",
                name: "modifiedBy",
                visibility: false
            },
            {
                label: "Módosítás dátuma",
                name: "modifiedOn",
                visibility: false
            },
            {
                label: "Opciók",
                name: "buttons",
                sort: false
            }
        ],


        evidenceDocumentTableRowActions: [
            {
                btn_text: '<i class="far fa-folder"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'showEvidenceDocument'
            },
        ],
        evidenceDocumentTableHeaderFields: [
            {
                label: "id",
                name: "Azonosító",
                visibility: false
            },
            {
                label: "Lelet azonosító",
                name: "patientEvidenceId",
                visibility: false
            },
            {
                label: "Fájl tartalom",
                name: "fileData",
                visibility: false
            },
            {
                label: "Fájl",
                name: "fileName",
                sort: true
            },
            {
                label: "Feltöltő",
                name: "createdBy",
                sort: true
            },
            {
                label: "Feltöltés dátuma",
                name: "createdOn",
                slot_name: "created_on_format",
                sort: true
            },
            {
                label: "Módosító",
                name: "modifiedBy",
                sort: true
            },
            {
                label: "Módosítás dátuma",
                name: "modifiedOn",
                slot_name: "modified_on_format",
                sort: true
            },
            {
                label: "Opciók",
                name: "buttons",
                sort: false
            }
        ],
        nonMedDocumentTableHeaderFields: [
            {
                label: "Azonosító",
                name: "id",
                visibility: false
            },
            {
                label: "Azonosító",
                name: "patientId",
                visibility: false
            },
            {
                label: "Fájl tartalom",
                name: "fileData",
                visibility: false
            },
            {
                label: "Fájlnév",
                name: "fileName",
                sort: true,
                visibility: true
            },
            {
                label: "Kategória",
                name: "documentCategory",
                visibility: true
            },
            {
                label: "Feltöltés időpontja",
                name: "createdOn",
                slot_name: "date_format",
                sort: true,
                visibility: true
            },
            {
                label: "Feltöltő",
                name: "createdBy",
                sort: true,
                visibility: true
            },
            // {
            //     label: "Módosítás dátuma",
            //     name: "modifiedOn",
            //     slot_name: "modified_on_format",
            //     sort: true,
            //     visibility: false,
            // },
            {
                label: "Opciók",
                name: "buttons",
                sort: false
            }
        ],
        nonMedDocumentTableRowActions: [
            {
                btn_text: '<i class="far fa-folder"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'showEvidenceDocument'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            }
        ],

        patientCovidResutlHeaderFields: [
            /*{
                label: "BNO",
                name: "apolastIndolkoFodiagnozis",
                visibility: true
            },
            {
                label: "Megnevezés",
                name: "leletAdatok.lelet.betegBnoNev",
                visibility: true
            },*/
            {
                label: "Teszt típusa",
                name: "covidResultType",
                visibility: true
            },
            {
                label: "Vizsgálat kezdete",
                name: "ellatasKezdete",
                visibility: true
            },
            /*{
                label: "Mintavétel időpontja",
                name: "leletAdatok.lelet.mintaVetelIdopont",
                visibility: true
            },
            {
                label: "Lelet kiadásának időpontja",
                name: "leletAdatok.lelet.leletKiadasIdopont",
                visibility: true
            },*/
            {
                label: "Eredmény",
                name: "covidPcrEredmeny",
                visibility: true
            },
            /*{
                label: "Vizsgáló labor",
                name: "leletAdatok.lelet.vizsgaloLaborNev",
                visibility: true
            }*/
        ],

        patientEvidenceBnoHeaderFields: [
            {
                name: "kod",
                label: "BNO kód",
                visibility: true,
                slot_name: "bnoKodFormat"
            },
            {
                name: "leiras",
                label: "Leírás",
                visibility: true,
                slot_name: "bnoKodFormat1"
            }
        ]
    }
}
